<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="80vw"
    persistent
    scrollable
  >
    <v-card class="rounded-lg d-flex flex-column" style="max-height: 90vh">
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title class="text-h5 font-weight-bold">
          <v-row>
            <v-col cols="auto" class="d-none d-md-flex">
              <v-icon large left>mdi-package</v-icon>
            </v-col>
            <v-col cols="auto" class="d-none d-sm-flex">
              <span> Paquetes pendientes </span>
            </v-col>
            <v-col cols="auto" class="d-flex d-sm-none">
              <span>pendientes</span>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid>
        <packages-table
          :laboratory="{}"
          :pending="true"
          @package_selected="handlePackageSelected"
        ></packages-table>
      </v-container>
      <v-card-actions class="flex-grow-0 px-2 pb-2 pt-1">
        <v-spacer></v-spacer>
        <v-btn
          color="grey darken-1"
          text
          @click="closeModal"
          :disabled="isLoading"
          class="px-2"
          small
        >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
    <reactions-modal
      v-model="showReactionsModal"
      :laboratory="{ name: null }"
      v-if="showReactionsModal"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import PackagesTable from "../PackagesTable.vue";
import ReactionsModal from "./ReactionModal.vue";

export default {
  components: { PackagesTable, ReactionsModal },
  data: () => ({
    isLoading: false,
    showReactionsModal: false,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("session", ["permissions"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {},
  methods: {
    ...mapMutations("laboratory", ["SET_PACKAGE_SELECTED"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    closeModal() {
      this.show = false;
    },
    handlePackageSelected(item) {
      this.SET_PACKAGE_SELECTED(item);
      this.showReactionsModal = true;
    },
  },
  async mounted() {},
  beforeDestroy() {
    this.$emit("fetch_count")
  },
};
</script>

<style scoped></style>
